import {Button, CounterLabel} from '@primer/react'
import type {FC} from 'react'
import styles from './FindingsFilterBar.module.css'

interface FindingsFilterBarProps {
  openCount: number
  resolvedCount: number
  activeFilter: 'open' | 'resolved'
  onFilterChange: (filter: 'open' | 'resolved') => void
}

export const FindingsFilterBar: FC<FindingsFilterBarProps> = ({
  openCount,
  resolvedCount,
  activeFilter,
  onFilterChange,
}) => {
  return (
    <div className={styles.filterBar}>
      <h2 className={styles.heading}>Findings</h2>
      <div className={styles.buttons}>
        <Button variant="invisible" onClick={() => onFilterChange('open')} aria-pressed={activeFilter === 'open'}>
          Open <CounterLabel>{openCount}</CounterLabel>
        </Button>
        <Button
          variant="invisible"
          onClick={() => onFilterChange('resolved')}
          aria-pressed={activeFilter === 'resolved'}
        >
          Resolved <CounterLabel>{resolvedCount}</CounterLabel>
        </Button>
      </div>
    </div>
  )
}
